export default {
  title: 'Nastavenia zobrazenia',
  subtitle: 'Z nasledujúcich zoznamov vyberte grafy, ktoré chcete zobraziť na paneli.',
  aggregationTitle: 'Agregácia',
  aggregationDescription: 'Tieto grafy zobrazujú výkon za celé zvolené časové obdobie',
};
